import { useState } from "react";
import { useLocation } from "react-router-dom";
import { AppSidebar } from "./AppSidebar";
import { TopBar } from "./TopBar";
import { PublicHeader } from "./PublicHeader";

export function DashboardLayout({
  children,
  showSidebar = true,
}: {
  children: React.ReactNode;
  showSidebar?: boolean;
}) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  const isCommunityRoute = location.pathname.startsWith("/community");

  if (!showSidebar) {
    return (
      <div className="flex flex-col min-h-screen bg-background w-full">
        <PublicHeader />
        <main className="flex-1 flex flex-col min-w-0">
          {children}
        </main>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen bg-background w-full">
      <AppSidebar
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        collapsed={collapsed}
        onToggleCollapse={() => setCollapsed(!collapsed)}
      />
      <div className="flex-1 flex flex-col min-w-0">
        <TopBar onMenuClick={() => setSidebarOpen(true)} />
        <main
          className={
            isCommunityRoute
              ? "flex-1 min-h-0 flex flex-col overflow-hidden"
              : "flex-1 min-h-0 flex flex-col overflow-y-auto"
          }
        >
          {children}
        </main>
      </div>
    </div>
  );
}

